import axios from "@/plugins/axios.js";
const token = localStorage.getItem("token");

export default {
  async getInvoicesAndQuotesData() {
    const invoicesData = await axios.getData(
      "/auth/get-invoices-and-quotations-data",
      localStorage.getItem("token")
    );
    return invoicesData;
  },
  //new
  async getInvoiceByInvoiceNumber(invoiceNumber) {
    let invoice = null;

    const response = await axios.postDataWithToken(
      "/auth/get-invoice-by-invoice-number",
      { invoiceNumber },
      token
    );

    if (response && response.status === "success") {
      invoice = response.invoice;
    }
    return invoice;
  },
  //new
  async getQuoteByQuoteNumber(quoteNumber) {
    let quote = null;

    const response = await axios.postDataWithToken(
      "/auth/get-quote-by-quote-number",
      { quoteNumber },
      token
    );

    if (response && response.status === "success") {
      quote = response.quote;
    }
    return quote;
  },
  //new
  async convertSelectedQuotesToInvoices(selectedQuotations) {
    if (selectedQuotations.length < 1) return false;

    const text = selectedQuotations.length > 1 ? "Quotations" : "Quotation";

    const response = await axios.postDataWithToken(
      "/auth/convert-quotes-to-invoices",
      {
        selectedQuotesForConversion: selectedQuotations,
      },
      localStorage.getItem("token")
    );

    return response;
  },
  async getSelectedInvoice(invoiceNumber) {
    const invoiceData = await axios.postDataWithToken(
      "/auth/get-selected-invoice",
      { invoiceNumber: invoiceNumber },
      localStorage.getItem("token")
    );
    return invoiceData;
  },
  async getInvoiceData(invoiceNumber) {
    const invoiceData = await axios.postDataWithToken(
      "/auth/get-invoice-data",
      { invoiceNumber: invoiceNumber },
      localStorage.getItem("token")
    );
    return invoiceData;
  },
  async saveInvoiceData(docType, client, invoiceObject, invoiceDate = null) {
    if (!invoiceDate) {
      invoiceDate = new Date().toISOString().substring(0, 10);
    }

    invoiceObject.client = client;
    invoiceObject.date = invoiceDate;
    invoiceObject.docType = docType;

    const response = await axios.postDataWithToken(
      "/auth/save-invoice-data",
      invoiceObject,
      localStorage.getItem("token")
    );
    return response;
  },

  reCalculateTotals(selectedInvoice, taxRate) {
    selectedInvoice.totalProducts = 0;
    selectedInvoice.totalServices = 0;
    selectedInvoice.totalTransports = 0;
    selectedInvoice.subTotal = 0;

    if (selectedInvoice.items.length > 0) {
      selectedInvoice.items.forEach((item) => {
        selectedInvoice.subTotal += Number(item.lineTotal);
        if (item.item_type == "product") {
          selectedInvoice.totalProducts += Number(item.lineTotal);
        } else if (item.item_type == "service") {
          selectedInvoice.totalServices += Number(item.lineTotal);
        } else if (item.item_type == "transportation") {
          selectedInvoice.totalTransports += Number(item.lineTotal);
        }
      });
    }

    selectedInvoice.totalTax = Number(
      (Number(selectedInvoice.subTotal) * (Number(taxRate) / 100)).toFixed(2)
    );

    selectedInvoice.totalInvoiceAmount =
      Number(selectedInvoice.subTotal) -
      Number(selectedInvoice.totalTax) -
      Number(selectedInvoice["discount"]);

    return selectedInvoice;
  },
};
